/* tslint:disable */
/* eslint-disable */
/**
 * User service API
 * Service for user management
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface NewUserRequestDto
 */
export interface NewUserRequestDto {
    /**
     * Personal names of a user. Usually it is a first name
     * @type {string}
     * @memberof NewUserRequestDto
     */
    firstName?: string;
    /**
     * Family names of a user. Usually it is a last name
     * @type {string}
     * @memberof NewUserRequestDto
     */
    lastName?: string;
    /**
     * User's email.
     * @type {string}
     * @memberof NewUserRequestDto
     */
    email: string;
    /**
     * Country code of user's telephone number
     * @type {string}
     * @memberof NewUserRequestDto
     */
    countryCode?: string;
    /**
     * User's telephone number without country code
     * @type {string}
     * @memberof NewUserRequestDto
     */
    phoneNumber?: string;
}

/**
 * Check if a given object implements the NewUserRequestDto interface.
 */
export function instanceOfNewUserRequestDto(value: object): boolean {
    if (!('email' in value)) return false;
    return true;
}

export function NewUserRequestDtoFromJSON(json: any): NewUserRequestDto {
    return NewUserRequestDtoFromJSONTyped(json, false);
}

export function NewUserRequestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): NewUserRequestDto {
    if (json == null) {
        return json;
    }
    return {
        
        'firstName': json['firstName'] == null ? undefined : json['firstName'],
        'lastName': json['lastName'] == null ? undefined : json['lastName'],
        'email': json['email'],
        'countryCode': json['countryCode'] == null ? undefined : json['countryCode'],
        'phoneNumber': json['phoneNumber'] == null ? undefined : json['phoneNumber'],
    };
}

export function NewUserRequestDtoToJSON(value?: NewUserRequestDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'firstName': value['firstName'],
        'lastName': value['lastName'],
        'email': value['email'],
        'countryCode': value['countryCode'],
        'phoneNumber': value['phoneNumber'],
    };
}

